import { render, staticRenderFns } from "./PayrollReceiver.vue?vue&type=template&id=37acf54a&scoped=true&"
import script from "./PayrollReceiver.vue?vue&type=script&lang=js&"
export * from "./PayrollReceiver.vue?vue&type=script&lang=js&"
import style0 from "./PayrollReceiver.vue?vue&type=style&index=0&id=37acf54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37acf54a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37acf54a')) {
      api.createRecord('37acf54a', component.options)
    } else {
      api.reload('37acf54a', component.options)
    }
    module.hot.accept("./PayrollReceiver.vue?vue&type=template&id=37acf54a&scoped=true&", function () {
      api.rerender('37acf54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/PayrollReceiver.vue"
export default component.exports